import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBCheckBox } from './DBCheckBox';

class DBCheckBoxObjective extends React.Component {

    handleValueChange() {
        if (!this.props.disabled === true) {
            if (!this.props.objUpdated) {
                this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTOBJECTIVEUPDATED', true);
            }else{
                if(typeof this.props.onClick === 'function'){
                    this.props.onClick(!this.props.value);
                }
            }
        }
    }

    render() {
        return (
            <DBCheckBox
                noteId={this.props.noteId}
                entity={this.props.entity}
                entityKeyColumn={this.props.entityKeyColumn}
                entityKeyValue={this.props.entityKeyValue}
                field={this.props.field}
                title={this.props.title}
                label={this.props.label}
                size={this.props.size}
                disabled={this.props.disabled}
                className={this.props.className}
                onClick={() => this.handleValueChange()}
            />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteType = parseInt(ownprops.noteId.split("_")[0]);
    let pk = parseInt(ownprops.noteId.split("_")[1]);
    let objUpdated = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTOBJECTIVEUPDATED : true;

    return {
        objUpdated,
        pk
    };
}

const connectedDBCheckBoxObjective = connect(mapStateToProps, mapDispatchToProps)(DBCheckBoxObjective);
export { connectedDBCheckBoxObjective as DBCheckBoxObjective };